import Logo from "../../assets/Logo.svg";

export default function CompanyInfo({
  containerClassName = "",
  contentClassName = "",
}) {
  return (
    <div
      className={`md:w-1/4 flex-col gap-[24px] items-center md:items-start text-center md:text-left text-[#111012B2] ${containerClassName}`}
    >
      <img
        src={Logo}
        alt="Logo"
        className="h-[25px] lg:h-[36px] md:mb-[10px] transition-[height]"
      />
      <p className="font-medium text-[15.5px] leading-[24px]">
        © 2025 ООО "НЕЙРОПРОДАКШН"
      </p>
      <p className="font-medium text-[13px] leading-[20px]">
        ИНН 7627062256
        <br />
        ОГРН 1257600007224
      </p>
    </div>
  );
}
